/*
 * Ascend – "Notify me when back in stock"
 * Pairs with snippets/ascend-restock-notify.liquid.
 *
 * - Shows the form only while the selected variant is sold out; hides it for
 *   in-stock variants and for unavailable option combinations (variant == null).
 * - Keeps the hidden contact[tags] value in sync with the selected variant.
 * - Success / error state: the footer newsletter is also a customer form, so
 *   form.posted_successfully? is shared. We only trust it when location.hash
 *   targets this form's id or this form was just submitted (sessionStorage).
 * - #restock (from collection "Notify me" links) scrolls to + focuses the field.
 * - Native POST only (no fetch) so Shopify's hCaptcha challenge still works.
 */
(function () {
  if (window.AscendRestock) return;

  var STORAGE_KEY = 'ascend-restock-pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000;

  function readPending() {
    try {
      var data = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (data && Date.now() - data.ts < PENDING_MAX_AGE) return data;
    } catch (e) {}
    return null;
  }

  function writePending(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function RestockNotify(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.formId = root.dataset.formId;
    this.productTitle = root.dataset.productTitle || '';
    this.singleVariant = root.dataset.singleVariant === 'true';
    this.form = root.querySelector('form');
    this.inner = root.querySelector('[data-restock-state]');
    this.tagsInput = root.querySelector('[data-restock-tags]');
    this.emailInput = root.querySelector('input[type="email"]');
    this.variantLabel = root.querySelector('[data-restock-variant-label]');
    this.successEl = root.querySelector('[data-restock-success]');
    this.successLabel = root.querySelector('[data-restock-success-label]');
    this.fieldsEl = root.querySelector('[data-restock-fields]');
    this.errorEl = root.querySelector('[data-restock-error]');

    try {
      this.variants = JSON.parse(root.querySelector('[data-restock-variants]').textContent);
    } catch (e) {
      this.variants = [];
    }

    this.currentVariant = this.findVariant(this.tagsInput && this.tagsInput.value.split('restock-').pop());

    this.resolvePostedState();
    this.bindEvents();
    this.handleAnchor();
  }

  RestockNotify.prototype.findVariant = function (id) {
    id = String(id || '');
    if (!id) return null;
    for (var i = 0; i < this.variants.length; i++) {
      if (String(this.variants[i].id) === id) return this.variants[i];
    }
    return null;
  };

  RestockNotify.prototype.labelFor = function (variant) {
    if (!variant || this.singleVariant) return this.productTitle;
    return this.productTitle + ' – ' + variant.title;
  };

  /* Decide whether the Liquid success/error state really belongs to this form. */
  RestockNotify.prototype.resolvePostedState = function () {
    var state = this.inner ? this.inner.dataset.restockState : 'default';
    var pending = readPending();
    var hash = window.location.hash.replace('#', '');
    var ours = hash === this.formId || (!!pending && pending.formId === this.formId && (!hash || hash === 'restock'));

    if (state === 'default') return;

    if (!ours) {
      // Another customer form (e.g. footer newsletter) was posted – show the normal form.
      this.showFields();
      if (this.errorEl) this.errorEl.hidden = true;
      if (this.emailInput) {
        this.emailInput.removeAttribute('aria-invalid');
        this.emailInput.removeAttribute('aria-describedby');
      }
      return;
    }

    this.root.hidden = false;

    if (state === 'success') {
      if (pending && pending.label && this.successLabel) this.successLabel.textContent = pending.label;
      clearPending();
      this.showSuccess();
    } else if (pending) {
      // Error: restore the variant the shopper was asking about.
      var variant = this.findVariant(pending.variantId);
      if (variant) this.setVariant(variant, true);
    }

    this.scrollIntoView(state === 'success' ? this.successEl : this.emailInput);
  };

  RestockNotify.prototype.showSuccess = function () {
    if (this.successEl) this.successEl.hidden = false;
    if (this.fieldsEl) this.fieldsEl.hidden = true;
  };

  RestockNotify.prototype.showFields = function () {
    if (this.successEl) this.successEl.hidden = true;
    if (this.fieldsEl) this.fieldsEl.hidden = false;
  };

  RestockNotify.prototype.setVariant = function (variant, force) {
    this.currentVariant = variant;
    var show = !!variant && variant.available === false;

    if (variant && this.tagsInput) {
      // Each tag stays well under 40 chars: "restock-" + 14-digit id = 22.
      this.tagsInput.value = 'restock-waitlist,restock-' + variant.id;
    }

    if (this.variantLabel && !this.singleVariant) {
      this.variantLabel.textContent = variant ? '(' + variant.title + ')' : '';
      this.variantLabel.hidden = !variant;
    }

    // Switching variants after a success resets to the form for the new variant.
    if (!force && this.successEl && !this.successEl.hidden) this.showFields();
    if (this.errorEl && !force) this.errorEl.hidden = true;

    this.root.hidden = !show;
  };

  RestockNotify.prototype.bindEvents = function () {
    var self = this;

    // Dawn product-info.js publishes this for every resolved variant.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== self.sectionId) return;
        var v = event.data.variant;
        self.setVariant(v ? self.findVariant(v.id) || { id: v.id, title: v.title, available: v.available } : null);
      });
    }

    // Unavailable combinations (variant == null) don't publish variantChange, but
    // product-info.js clears the product form's id input and fires "change".
    var productForm = document.getElementById('product-form-' + this.sectionId);
    var idInput = productForm && productForm.querySelector('input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () {
        if (!idInput.value) self.setVariant(null);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function () {
        writePending({
          formId: self.formId,
          variantId: self.currentVariant && self.currentVariant.id,
          label: self.labelFor(self.currentVariant),
          ts: Date.now(),
        });
        var btn = self.form.querySelector('[data-restock-submit]');
        if (btn) btn.setAttribute('aria-busy', 'true');
      });
    }

    window.addEventListener('hashchange', function () {
      self.handleAnchor();
    });
  };

  RestockNotify.prototype.handleAnchor = function () {
    if (window.location.hash !== '#restock' || this.root.hidden) return;
    if (this.fieldsEl && this.fieldsEl.hidden) return;
    this.scrollIntoView(this.emailInput, true);
  };

  RestockNotify.prototype.scrollIntoView = function (target, focus) {
    if (!target) return;
    var self = this;
    requestAnimationFrame(function () {
      self.root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
      if (focus !== false) target.focus({ preventScroll: true });
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-ascend-restock]').forEach(function (root) {
      if (root.ascendRestock) return;
      // Never inside the quick-add modal (native POST would lose the modal state).
      if (root.closest('quick-add-modal, .quick-add-modal')) {
        root.hidden = true;
        return;
      }
      root.ascendRestock = new RestockNotify(root);
    });
  }

  window.AscendRestock = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor: re-init when the product section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();